import React, { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";

function PortalSourceSelect({ value, onChange, required = false }) {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get("/client/lead-meta");
        if (active) {
          setSources(Array.isArray(res.data?.data?.sources) ? res.data.data.sources : []);
        }
      } catch (_) {
        if (active) setSources([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const hasCurrentValue =
    value &&
    !sources.some(
      (s) => String(s.Source_Name || s.source_name || "") === String(value)
    );

  return (
    <div className="cportal-field">
      <label>
        Source
        {required ? (
          <>
            {" "}
            <span className="cportal-required">*</span>
          </>
        ) : null}
      </label>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        required={required}
      >
        <option value="">Select source</option>
        {hasCurrentValue && <option value={value}>{value}</option>}
        {sources.map((source) => {
          const id = source.Source_Id ?? source.source_id;
          const name = source.Source_Name ?? source.source_name ?? "";
          return (
            <option key={id} value={name}>
              {name}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default PortalSourceSelect;
